import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiChecklist2ListNameComponent } from '@fi-shared/checklist/fi-checklist2-list-column-defs/fi-checklist2-list-name/fi-checklist2-list-name.component';
import { MatTableModule } from '@angular/material/table';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { FiChecklist2ListScheduleNameComponent } from './fi-checklist2-list-schedule-name/fi-checklist2-list-schedule-name.component';
import { FiChecklist2ListChangedOnComponent } from './fi-checklist2-list-changed-on/fi-checklist2-list-changed-on.component';
import { FiChecklist2ListStartDateComponent } from './fi-checklist2-list-start-date/fi-checklist2-list-start-date.component';
import { FiChecklist2ListDueDateComponent } from './fi-checklist2-list-due-date/fi-checklist2-list-due-date.component';
import { FiChecklist2ListActionsComponent } from './fi-checklist2-list-actions/fi-checklist2-list-actions.component';
import { FiChecklist2ListCheckpointsStatusComponent } from './fi-checklist2-list-checkpoints-status/fi-checklist2-list-checkpoints-status.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiChecklist2ListProgressCellComponent } from '@fi-shared/checklist/fi-checklist2-list-column-defs/fi-checklist2-list-progress-cell/fi-checklist2-list-progress-cell.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FiChecklist2ListCheckpointsCountComponent } from './fi-checklist2-list-checkpoints-count/fi-checklist2-list-checkpoints-count.component';
import { FiChecklist2ListScoringComponent } from '@fi-shared/checklist/fi-checklist2-list-column-defs/fi-checklist2-list-scoring/fi-checklist2-list-scoring.component';
import { FiLineClampModule } from '@fi-shared/fi-directives/fi-line-clamp/fi-line-clamp.module';
import { FiChecklist2ListUnitNameComponent } from '@fi-shared/checklist/fi-checklist2-list-column-defs/fi-checklist2-list-unit-name/fi-checklist2-list-unit-name.component';

@NgModule({
    imports: [
        CommonModule,
        MatTableModule,
        FiWrapperTableModule,
        FiAppTextSharedModule,
        MatProgressBarModule,
        FiLineClampModule,
    ],
    declarations: [
        FiChecklist2ListProgressCellComponent,
        FiChecklist2ListNameComponent,
        FiChecklist2ListUnitNameComponent,
        FiChecklist2ListScheduleNameComponent,
        FiChecklist2ListChangedOnComponent,
        FiChecklist2ListStartDateComponent,
        FiChecklist2ListDueDateComponent,
        FiChecklist2ListActionsComponent,
        FiChecklist2ListCheckpointsStatusComponent,
        FiChecklist2ListCheckpointsCountComponent,
        FiChecklist2ListScoringComponent,
    ],
    exports: [
        FiChecklist2ListProgressCellComponent,
        FiChecklist2ListNameComponent,
        FiChecklist2ListUnitNameComponent,
        FiChecklist2ListScheduleNameComponent,
        FiChecklist2ListChangedOnComponent,
        FiChecklist2ListStartDateComponent,
        FiChecklist2ListDueDateComponent,
        FiChecklist2ListActionsComponent,
        FiChecklist2ListCheckpointsStatusComponent,
        FiChecklist2ListCheckpointsCountComponent,
        FiChecklist2ListScoringComponent,
    ],
})
export class FiChecklist2ListColumnDefsModule {}
